module.exports = __webpack_public_path__ + "static/media/feather-icons.7722907d.jpg";